import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { UIRoutes } from '../UIRoutes';
import { AppConstants } from '../AppConstants';
import { ColDef, GridOptions } from 'ag-grid-community';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  SA = false;
  usersData: any[] = [];
  filteredUsersData: any[] = [];
  externalUserContext: any;
  currentUserContext: any;
  roleId: any;
  columnDefs: ColDef[] = [];
  mobileColumnDefs: ColDef[] = [];
  //gridOptions: GridOptions = <GridOptions>{};
  searchText: string = '';
  showEditModal: boolean = false;
  selectedUser: any = null;
  isLoading = false;
  isEditMode = false;
  profileForm!: FormGroup;
  tenants:any;
  gridOptions: GridOptions = {
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: true
    },
    onRowClicked: (event: any) => this.openEditModal(event.data)
  };

  roleMap: { [key: number]: string } = {
    1: 'Super Admin',
    2: 'Tenant Admin',
    3: 'End User'
  };

  roleOptions = [
    { id: 1, label: 'Super Admin' },
    { id: 2, label: 'Tenant Admin' },
    { id: 3, label: 'End User' }
  ];

  constructor(private authService: AuthService, private fb: FormBuilder) {}

  ngOnInit() {
    this.externalUserContext = sessionStorage.getItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT);
    this.currentUserContext = sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT);
    console.log('Landing page ', this.currentUserContext);
    console.log('Landing page ext ', this.externalUserContext);

    if (this.externalUserContext) {
      this.roleId = JSON.parse(this.externalUserContext).roleId;
    } else if (this.currentUserContext) {
      this.roleId = JSON.parse(this.currentUserContext).roleId;
    } else {
      this.roleId = 0; // User not logged in
    }

    if (this.roleId == 1) {
      this.SA = true;
      this.getAllUsers(); // Load users only for Super Admin
    } else {
      this.SA = false;
    }

    // Define columns for desktop and mobile
    this.columnDefs = [
      { headerName: 'ID', field: 'id', width: 60 },
      { headerName: 'NAME', valueGetter: (params) => `${params.data.firstName} ${params.data.lastName}`, width: 180 },
      { headerName: 'EMAIL', field: 'email', width: 200 },
      { headerName: 'PHONE', field: 'phoneNumber', width: 120 },
      { headerName: 'STATUS', field: 'status', width: 100 },
      { headerName: 'TENANT', field: 'tenantId', width: 100 },
      { headerName: 'ROLE', field: 'roleId', width: 80 },
      { headerName: 'LOGIN', field: 'lastlogin', width: 200 }
    ];

    this.mobileColumnDefs = [
      { headerName: 'ID', field: 'id', width: 60 },
      { headerName: 'NAME', valueGetter: (params) => `${params.data.firstName} ${params.data.lastName}`, width: 180 },
      { headerName: 'EMAIL', field: 'email', width: 200 },
      { headerName: 'PHONE', field: 'phoneNumber', width: 120 },
      { headerName: 'STATUS', field: 'status', width: 100 },
      { headerName: 'TENANT', field: 'tenantId', width: 100 }
    ];
    this.getAllTenants();
    this.updateColumnDefs();
  }

  updateColumnDefs() {
    const isMobile = window.innerWidth < 600; // Adjust the breakpoint as needed
    if (isMobile) {
      console.log('Mobile');
      this.gridOptions.columnDefs = this.mobileColumnDefs;
    } else {
      console.log('Desktop');
      this.gridOptions.columnDefs = this.columnDefs;
    }
  }
  getAllTenants() {
    this.authService.getAlltenants().subscribe(
      (response: any[]) => {
        console.log("Tenants: ", response);
        this.tenants = response;
      },
      (error) => {

      }
    );
   }
   getTenantName(id: number): string {
     const tenant = this.tenants.find(t => t.id === id);
     return tenant ? tenant.tenantName : 'Unknown';
   }


  getAllUsers() {
    console.log('Users : GetAllUsers');
    this.authService.getAllUsers().subscribe(
      (response: any[]) => {
        console.log('Users: ', response);
        this.usersData = response;
        this.filteredUsersData = [...this.usersData]; // Initialize filtered data
      },
      (error) => {
        console.error('Error fetching users:', error);
      }
    );
  }

  openEditModal(user: any) {
    this.selectedUser = { ...user };
    this.isEditMode = false;
    this.profileForm = this.fb.group({
      firstName: [{ value: this.selectedUser.firstName, disabled: true }, Validators.required],
      lastName: [{ value: this.selectedUser.lastName, disabled: true }, Validators.required],
      phoneNumber: [
        { value: this.selectedUser.phoneNumber, disabled: true },
        [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]
      ],
      roleId: [{ value: this.selectedUser.roleId, disabled: true }],
      tenantId: [{ value: this.selectedUser.tenantId, disabled: true }]
    });
    this.showEditModal = true;
  }


  closeEditModal() {
    this.selectedUser = null;
    this.showEditModal = false;
  }

  saveUserChanges() {
    if (this.profileForm.invalid) return;

    this.isLoading = true;

    const updatedData = {
      ...this.profileForm.value,
      roleId: Number(this.profileForm.get('roleId')?.value),
      tenantId: Number(this.profileForm.get('tenantId')?.value)
    };

    this.authService.updateUserDetails(updatedData, this.selectedUser.id).subscribe({
      next: () => {
        this.isEditMode = false;
        this.isLoading = false;
        this.profileForm.disable();
        this.closeEditModal();
        this.getAllUsers();
      },
      error: (err) => {
        console.error('Failed to update profile', err);
        this.isLoading = false;
      }
    });
  }

 /*  saveUserChanges() {
    console.log("Update user", this.selectedUser);
    if (this.profileForm.invalid) return;
        this.isLoading = true;
        this.authService.updateUserDetails(this.profileForm.value, this.selectedUser.id).subscribe({
          next: () => {
            this.isEditMode = false;
            this.isLoading = false;
            this.profileForm.disable();
          },
          error: (err) => {
            console.error('Failed to update profile', err);
            this.isLoading = false;
          }
       });
      this.closeEditModal();

  } */


  toggleEdit(): void {
    this.isEditMode = !this.isEditMode;

    if (this.isEditMode) {
      this.profileForm.enable();
    } else {
      this.profileForm.reset(this.selectedUser);  // restore original values
      this.profileForm.disable();
    }
  }

  search() {
    console.log('Search string: ', this.searchText);
    const searchTextLower = this.searchText.toLowerCase();

    this.filteredUsersData = this.usersData.filter(user =>
      Object.values(user).some(value =>
        value.toString().toLowerCase().includes(searchTextLower)
      )
    );

    if (this.gridOptions.api) {
      this.gridOptions.api.setRowData(this.filteredUsersData);
    }
  }
}



/*
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { UIRoutes } from '../UIRoutes';
import { AppConstants } from '../AppConstants';
import { ColDef, GridOptions } from 'ag-grid-community';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  constructor(private authService: AuthService) {

    this.gridOptions = <GridOptions>{};

  }

  SA = false;

  usersData = [];
  externalUserContext;
  currentUserContext;
  roleId;
  columnDefs: ColDef[] = [];
  mobileColumnDefs: ColDef[] = [];
  gridOptions: GridOptions;
  searchText:any;




  ngOnInit() {

        this.externalUserContext =  sessionStorage.getItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT);
        this.currentUserContext = sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT);
        console.log('Landing page ', this.currentUserContext);
        console.log('Landing page ext ',this.externalUserContext);

        if(this.externalUserContext) {
          this.roleId = JSON.parse(this.externalUserContext).roleId;
        } else if(this.currentUserContext) {
          this.roleId = JSON.parse(this.currentUserContext).roleId;
        } else {
          this.roleId = 0; // user not logged in
        }

        if(this.roleId == 1)
        {
          this.SA = true;
          this.getAllUsers(); // Only for Superadmin Need to add condition
        }
        else
        {
          this.SA = false;
        }

          this.columnDefs = [
              { headerName: 'ID', field: 'id', width: 60 },
              { headerName: 'NAME',  valueGetter: (params) => `${params.data.firstName} ${params.data.lastName}`, width: 180 },
              { headerName: 'EMAIL', field: 'email', width: 200 },
              { headerName: 'PHONE', field: 'phoneNumber', width: 120},
              { headerName: 'STATUS', field: 'status', width: 100},
              { headerName: 'TENANT', field: 'tenantId', width: 100},
              { headerName: 'ROLE', field: 'roleId', width: 80},
              { headerName: 'LOGIN', field: 'lastlogin', width: 200}
          ];

          this.mobileColumnDefs = [
                { headerName: 'ID', field: 'id' , width: 60  },
                { headerName: 'NAME',  valueGetter: (params) => `${params.data.firstName} ${params.data.lastName}`, width: 180 },
                { headerName: 'EMAIL', field: 'email' , width: 200 },
                { headerName: 'PHONE', field: 'phoneNumber' , width: 120},
                { headerName: 'STATUS', field: 'status' , width: 100},
                { headerName: 'TENANT', field: 'tenantId', width: 100},

          ];

        this.updateColumnDefs();

  }

  updateColumnDefs() {
        const isMobile = window.innerWidth < 600; // Adjust the breakpoint as needed

        if (isMobile) {
        console.log("Mobile");
          this.gridOptions.columnDefs = this.mobileColumnDefs;

        } else {
         console.log("Desktop");
          this.gridOptions.columnDefs = this.columnDefs;
        }
    }

  getAllUsers()
  {
      console.log("Users : GetAllUsers ");
      this.authService.getAllUsers().subscribe(
      (response: any[]) => {
        console.log("Users: ", response);

        this.usersData = response;
        console.log(" Users Data : ", this.usersData);
      },
      (error) => {

      }
      );
  }

  search() {
      console.log("search string: ", this.searchText);
      if (this.gridOptions.api) {
        this.gridOptions.api.setQuickFilter(this.searchText);
      }
  }

}
 */
